/* eslint-disable react/prop-types */
import React, { createContext, useContext, useEffect, useMemo, useState } from 'react'

export const TabContext = createContext({})

export const useTabContext = () => {
  const provided = useContext(TabContext)
  return provided
}

export function TabProvider({ tabs, children, initialTabId = null }) {
  const tabKeys = useMemo(() => (tabs || []).map((tab) => tab?.key).join(','), [tabs])
  const [activeTab, setActiveTab] = useState(() => initialTabId || tabs?.[0]?.key || null)

  useEffect(() => {
    setActiveTab((currentTab) => {
      if (currentTab && tabs?.some((tab) => tab?.key === currentTab)) {
        return currentTab
      }
      if (initialTabId && tabs?.some((tab) => tab?.key === initialTabId)) {
        return initialTabId
      }
      return tabs?.[0]?.key || null
    })
  }, [tabKeys, initialTabId, tabs])

  const provided = useMemo(
    () => ({
      tabs,
      activeTab,
      setActiveTab,
    }),
    [tabs, activeTab],
  )

  return <TabContext.Provider value={provided}>{children}</TabContext.Provider>
}

export function TabSwitch(props) {
  const { children, tab } = props
  const { activeTab } = useTabContext()

  if (activeTab && activeTab !== tab) {
    return null
  }

  return children
}
